export const AGREEMENT_STATUS_NOT_SENT = "not_sent";
export const AGREEMENT_STATUS_SENT = "sent";
export const AGREEMENT_STATUS_COMPLETED = "completed";

export const AGREEMENT_STATUS_LABEL = {
  [AGREEMENT_STATUS_NOT_SENT]: "NOT SENT",
  [AGREEMENT_STATUS_SENT]: "SENT",
  [AGREEMENT_STATUS_COMPLETED]: "COMPLETED",
} as const;

export const AGREEMENT_TAB_TITLE = "Agreement";

export const AGREEMENT_LABEL_ARPA = "ARPA";
export const AGREEMENT_LABEL_PSA = "PSA";
export const AGREEMENT_LABEL_OIF = "OIF";

export const AGREEMENT_TEMPLATE_ARPA = "arpa";
export const AGREEMENT_TEMPLATE_PSA = "psa";
export const AGREEMENT_TEMPLATE_OIF = "oif";
export const AGREEMENT_TEMPLATE_PSA_OIF = "psa_oif";
